module.exports = __webpack_public_path__ + "media/5.0e20fb28.wav";